export const getFixedConservatories = alias => [
  {
    name: alias.bfcFrameTypeFira,
    description: alias.bfcBackConnection,
    url: alias.bfcValldaImageUrl,
    icon: "",
    value: "PULPET",
    connected: "fixed",
    availableWithConfig: true,
    imagelistAlias: "Uterumsguide_imagelist_pulpet",
  },
  {
    name: alias.bfcFrameTypeFira5050,
    description: alias.bfcBackConnection,
    url: alias.bfcVallda50ImageUrl,
    icon: "",
    value: "PULPET50-50",
    connected: "fixed",
    availableWithConfig: true,
    imagelistAlias: "Uterumsguide_imagelist_pulpet50-50",
  },

  {
    name: alias.bfcFrameTypeFiraXL,
    description: alias.bfcBackConnection,
    url: alias.bfcValldaXlImageUrl,
    icon: "",
    value: "FIRAXL",
    connected: "fixed",
    availableWithConfig: true,
    imagelistAlias: "Uterumsguide_imagelist_pulpetHigh",
  },

  {
    name: alias.bfcFrameTypeGladja,
    description: alias.bfcBackConnection,
    url: alias.bfcKovlandImageUrl,
    icon: "",
    value: "SADEL",
    connected: "fixed",
    availableWithConfig: true,
    imagelistAlias: "Uterumsguide_imagelist_sadel",
  },
  {
    name: alias.bfcFrameTypeSkapa,
    description: alias.bfcSideConnection,
    url: alias.bfcSandnesImageUrl,
    icon: "",
    value: "SKAPA",
    connected: "fixed",
    availableWithConfig: true,
    imagelistAlias: "Uterumsguide_imagelist_skapa",
  },
  {
    name: alias.bfcFrameTypeFiraVinkel,
    description: alias.bfcBackConnection,
    url: alias.bfcFiraVinkelImageUrl,
    icon: "",
    value: "FIRAVINKEL",
    connected: "fixed",
    availableWithConfig: true,
    imagelistAlias: "Uterumsguide_imagelist_firavinkel",
  },
];

export const getFreeConservatories = alias => [
  {
    name: alias.bfcFrameTypeOnska,
    description: alias.bfcIndependentConnection,
    url: alias.bfcKoldingImageUrl,
    icon: "",
    value: "ONSKA",
    connected: "free",
    availableWithConfig: true,
    imagelistAlias: "Uterumsguide_imagelist_onska",
  },
  {
    name: alias.bfcFrameTypeTjusa,
    description: alias.bfcIndependentConnection,
    url: alias.bfcRaumaImageUrl,
    icon: "",
    value: "TJUSA",
    connected: "free",
    availableWithConfig: true,
    imagelistAlias: "Uterumsguide_imagelist_tjusa",
  },
  {
    name: alias.bfcFrameTypeLycka,
    description: alias.bfcIndependentConnection,
    url: alias.bfcLyckaImageUrl,
    icon: "",
    value: "LYCKA",
    connected: "free",
    availableWithConfig: true,
    imagelistAlias: "Uterumsguide_imagelist_lycka",
  },
];
